/*!
 * Link binding handlers whose value is already attached to the node 🥊  @tko/provider.native@4.0.0-alpha7.4
 * (c) The Knockout.js Team - https://tko.io
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

import { isObservable } from '@tko/observable';
import { Provider } from '@tko/provider';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var NATIVE_BINDINGS = Symbol('Knockout native bindings');
/**
 * Retrieve the binding accessors that are already attached to
 * a node under the `NATIVE_BINDINGS` symbol.
 *
 * Used by the jsxToNode function.
 */
var NativeProvider = /** @class */ (function (_super) {
    __extends(NativeProvider, _super);
    function NativeProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NativeProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return [1]; } // document.ELEMENT_NODE
        ,
        enumerable: true,
        configurable: true
    });
    NativeProvider.prototype.nodeHasBindings = function (node) {
        return Object.keys(node[NATIVE_BINDINGS] || {})
            .some(function (key) { return key.startsWith('ko-'); });
    };
    NativeProvider.prototype.onlyBindings = function (_a) {
        var _b = __read(_a, 1), name = _b[0];
        return name.startsWith('ko-');
    };
    NativeProvider.prototype.valueAsAccessor = function (_a) {
        var _b = __read(_a, 2), name = _b[0], value = _b[1];
        var _c;
        var bindingName = name.replace(/^ko-/, '');
        var valueFn = isObservable(value) ? value : function () { return value; };
        return _c = {}, _c[bindingName] = valueFn, _c;
    };
    /**
     * Return as valueAccessor function all the entries matching `ko-*`
     * @param {HTMLElement} node
     */
    NativeProvider.prototype.getBindingAccessors = function (node) {
        return Object.assign.apply(Object, __spread([{}], Object.entries(node[NATIVE_BINDINGS] || {})
            .filter(this.onlyBindings)
            .map(this.valueAsAccessor)));
    };
    /**
     * Add a named-value to the given node.
     * @param {HTMLElement} node
     * @param {string} name
     * @param {any} value
     */
    NativeProvider.addValueToNode = function (node, name, value) {
        var obj = node[NATIVE_BINDINGS] || (node[NATIVE_BINDINGS] = {});
        obj[name] = value;
    };
    /**
     *
     * @param {HTMLElement} node
     * @return {object} the stored values
     */
    NativeProvider.getNodeValues = function (node) {
        return node[NATIVE_BINDINGS];
    };
    return NativeProvider;
}(Provider));

export { NativeProvider };
//# sourceMappingURL=provider.native.js.map
